import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IDashUnitStatsModel } from '@apps-common/types/portal/dashboard'

export const getDashUnitStats = async (): Promise<IDashUnitStatsModel> =>
  axios.get('/dashwidget/getunitstats').then((res) => res.data?.data)

type QueryFnType = typeof getDashUnitStats

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useGetDashUnitStats = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getDashUnitStats'],
    queryFn: () => getDashUnitStats()
  })
